import React, { useEffect, useState } from "react";

import {
    Box,
    Card,
    CardContent,
    Typography,
    Button,
    TextField,
    Stack,
    Snackbar,
    Alert,
    CircularProgress,
    Dialog,
    DialogTitle,
    DialogContent,
    DialogActions,
    MenuItem,
    Grid,
    Chip,
} from "@mui/material";

import { DataGrid } from "@mui/x-data-grid";

import FactoryStockService from "../../services/FactoryStockService";

const DeviceConfigConsole = () => {

    const [step1Completed, setStep1Completed] = useState(false);
    const [step2Completed, setStep2Completed] = useState(false);
    const [step3Completed, setStep3Completed] = useState(false);
    const [step4Completed, setStep4Completed] = useState(false);

    /* ==========================================
              TABLE
    ========================================== */

    const [rows, setRows] = useState([]);

    const [loading, setLoading] = useState(false);

    const [page, setPage] = useState(0);

    const [pageSize, setPageSize] = useState(50);

    const [rowCount, setRowCount] = useState(0);

    const [search, setSearch] = useState("");

    /* ==========================================
              DIALOG
    ========================================== */

    const [open, setOpen] = useState(false);

    const [selectedRow, setSelectedRow] = useState(null);

    /* ==========================================
              FOTA OPTIONS
    ========================================== */

    const [vendorList, setVendorList] = useState([]);

    const [modelList, setModelList] = useState([]);

    const [protocolList, setProtocolList] = useState([]);

    const [vendor, setVendor] = useState("");

    const [model, setModel] = useState("");

    const [protocol, setProtocol] = useState("");

    const [firmwareList, setFirmwareList] = useState([]);
    const [manufacturerList, setManufacturerList] = useState([]);

    const [manufacturer, setManufacturer] = useState("");

    /* ==========================================
              COMMANDS
    ========================================== */

    const [configCommand, setConfigCommand] =
        useState("");

    const [checkCommand, setCheckCommand] =
        useState("");

    /* ==========================================
              HISTORY
    ========================================== */

    const [history, setHistory] = useState([]);

    /* ==========================================
              STATUS
    ========================================== */

    const [fotaStatus, setFotaStatus] =
        useState("");

    const [matched, setMatched] =
        useState(false);

    /* ==========================================
              BUTTON LOADING
    ========================================== */

    const [sendingFota, setSendingFota] =
        useState(false);

    const [refreshingStatus,
        setRefreshingStatus] =
        useState(false);

    const [sendingConfig,
        setSendingConfig] =
        useState(false);

    const [checkingConfig,
        setCheckingConfig] =
        useState(false);

    const [markingDone,
        setMarkingDone] =
        useState(false);

    /* ==========================================
              SNACKBAR
    ========================================== */

    const [snackbar, setSnackbar] =
        useState({

            open: false,

            severity: "success",

            message: "",

        });

    const showSnackbar = (
        message,
        severity = "success"
    ) => {

        setSnackbar({

            open: true,

            severity,

            message,

        });

    };

    /* ==========================================
              DEVICE LIST
    ========================================== */

    const fetchDeviceList = async (
        currentPage = page,
        currentSearch = search
    ) => {

        try {

            setLoading(true);

            const response =
                await FactoryStockService.configList({

                    page: currentPage + 1,

                    page_size: pageSize,

                    search: currentSearch,

                });

            const data = response.data;

            setRows(data.results || []);

            setRowCount(data.count || 0);

        } catch (error) {

            console.log(error);

            showSnackbar(
                "Unable to load devices",
                "error"
            );

        } finally {

            setLoading(false);

        }

    };

    /* ==========================================
              FOTA OPTIONS
    ========================================== */

    const fetchFotaOptions =
        async () => {

            try {

                const response =
                    await FactoryStockService.getFotaOptions();

                const data = response.data;

                const vendors = Object.keys(data.vendors || {}).map((key) => ({
                    vendor: key,
                    ...data.vendors[key],
                }));

                setVendorList(vendors);

                setProtocolList(data.protocol_formats || []);

            } catch (error) {

                console.log(error);

            }

        };


    const fetchManufacturers = async () => {
        try {

            const response =
                await FactoryStockService.getVendorManufacturerCatalog("MAPW");

            /*
                Expected response
    
                [
                   {
                      manufacturer_id:1,
                      manufacturer_name:"Quectel",
                      models:[...]
                   }
                ]
            */

            const manufacturers = (response.data || []).map(item => ({
                id: item.id,
                company_name: item.company_name,
                device_models: item.device_models || []
            }));

            setManufacturerList(manufacturers);

        } catch (error) {

            console.log(error);

            showSnackbar(
                "Unable to load manufacturers",
                "error"
            );
        }
    };
    /* ==========================================
              HISTORY
    ========================================== */

    const fetchHistory =
        async (imei) => {

            try {

                const response =
                    await FactoryStockService.getCommandHistory(
                        imei
                    );

                setHistory(response.data.history || []);

            } catch (error) {

                console.log(error);

            }

        };

    /* ==========================================
              INITIAL LOAD
    ========================================== */

    useEffect(() => {

        fetchDeviceList();

        fetchFotaOptions();

    }, [page, pageSize]);

    /* ==========================================
            SEARCH
  ========================================== */

    const handleSearch = () => {

        setPage(0);

        fetchDeviceList(0, search);

    };

    const handleReset = () => {

        setSearch("");

        setPage(0);

        fetchDeviceList(0, "");

    };

    /* ==========================================
              OPEN CONFIG DIALOG
    ========================================== */

    const handleOpenDialog = async (row) => {

        setSelectedRow(row);

        setVendor("");

        setModel("");

        setProtocol("");

        setConfigCommand("");

        setCheckCommand("");

        setFotaStatus(row.fota_status || "");

        setMatched(false);

        setOpen(true);

        setStep1Completed(false);
        setStep2Completed(false);
        setStep3Completed(false);
        setStep4Completed(false);

        await fetchHistory(row.imei);
        await fetchManufacturers();

    };

    /* ==========================================
              CLOSE DIALOG
    ========================================== */

    const handleCloseDialog = () => {
        setStep1Completed(false);
        setStep2Completed(false);
        setStep3Completed(false);
        setStep4Completed(false);

        setFirmwareList([]);
        setModelList([]);
        setManufacturer("");
        setManufacturerList([]);
        setVendor("");
        setModel("");
        setProtocol("");
        setOpen(false);

        setSelectedRow(null);

        setHistory([]);

    };

    /* ==========================================
              VENDOR CHANGE
    ========================================== */

    // const handleVendorChange = (e) => {

    //     const value = e.target.value;

    //     setVendor(value);

    //     setModel("");
    //     setProtocol("");
    //     setManufacturer("");

    //     const selectedVendor = vendorList.find(
    //         item => item.vendor === value
    //     );

    //     setModelList(selectedVendor?.models || []);
    //     setFirmwareList(selectedVendor?.firmware || []);
    // };
    const handleVendorChange = (e) => {

    setVendor(e.target.value);

    setManufacturer("");
    setModel("");
    setProtocol("");

    setModelList([]);
    setFirmwareList([]);
};

const handleManufacturerChange = (e) => {

    const manufacturerId = Number(e.target.value);

    setManufacturer(manufacturerId);

    setModel("");
    setProtocol("");
    setFirmwareList([]);

    const company = manufacturerList.find(
        item => item.id === manufacturerId
    );

    console.log("Manufacturer:", company);

    setModelList(company?.device_models || []);
};

    const handleModelChange = (e) => {

    const modelId = Number(e.target.value);

    setModel(modelId);

    setProtocol("");

    const company = manufacturerList.find(
        item => item.id === manufacturer
    );

    const selectedModel = company?.device_models.find(
        item => item.id === modelId
    );

    setFirmwareList(selectedModel?.firmwares || []);
};

const handleProtocolChange = (e) => {

    setProtocol(e.target.value);
};

    /* ==========================================
              SEND FOTA
    ========================================== */

    const handleSendFota = async () => {

        try {

            setSendingFota(true);

            await FactoryStockService.sendFota({

                imei: selectedRow.imei,

                vendor,

                model_id: model,

                protocol_format: protocol,

                manufacturer_id: manufacturer,

            });

            setStep1Completed(true);
            showSnackbar(
                "FOTA Command Sent Successfully"
            );

            fetchHistory(selectedRow.imei);

        } catch (error) {

            console.log(error);

            showSnackbar(

                error.response?.data?.error ||

                "Unable to send FOTA",

                "error"

            );

        } finally {

            setSendingFota(false);

        }

    };

    /* ==========================================
              REFRESH STATUS
    ========================================== */

    const handleRefreshStatus = async () => {

        try {

            setRefreshingStatus(true);

            const response =
                await FactoryStockService.refreshFotaStatus({

                    imei: selectedRow.imei,

                });

            const status = (response.data.fota_status || "").toLowerCase();

            setFotaStatus(response.data.fota_status || "");

            if (
                status === "success" ||
                status === "confirmed" ||
                status === "confirm"
            ) {
                setStep2Completed(true);
            }

            showSnackbar(

                "FOTA Status Updated"

            );

            fetchHistory(selectedRow.imei);

        } catch (error) {

            console.log(error);

            showSnackbar(

                "Unable to refresh status",

                "error"

            );

        } finally {

            setRefreshingStatus(false);

        }

    };

    /* ==========================================
              SEND CONFIG
    ========================================== */

    const handleSendConfig = async () => {

        if (!configCommand.trim()) {
            showSnackbar(
                "Configuration command cannot be blank.",
                "warning"
            );
            return;
        }

        try {

            setSendingConfig(true);

            await FactoryStockService.sendConfig({

                imei: selectedRow.imei,

                commands: [

                    configCommand,

                ],

            });

            setStep3Completed(true);

            showSnackbar(

                "Configuration Sent"

            );

            setConfigCommand("");

            fetchHistory(selectedRow.imei);

        } catch (error) {

            console.log(error);

            showSnackbar(

                "Configuration Failed",

                "error"

            );

        } finally {

            setSendingConfig(false);

        }

    };

    /* ==========================================
              CHECK CONFIG
    ========================================== */

    const handleVerifyConnectivity = async () => {

        try {

            setCheckingConfig(true);

            const response =
                await FactoryStockService.verifyConnectivity({

                    imei: selectedRow.imei,

                });

            console.log(response.data);

            const matched =
                response.data.matched ||
                response.data.connected ||
                response.data.success ||
                false;

            setMatched(matched);

            if (matched) {
                setStep4Completed(true);
            }

            showSnackbar(
                matched
                    ? "Device Connectivity Verified"
                    : "Device Not Connected",
                matched ? "success" : "warning"
            );

            fetchHistory(selectedRow.imei);

        } catch (error) {

            console.log(error);

            showSnackbar(
                error?.response?.data?.message ||
                "Connectivity Check Failed",
                "error"
            );

        } finally {

            setCheckingConfig(false);

        }

    };

    const handleCheckConfig = async () => {

        if (!checkCommand.trim()) {
            showSnackbar(
                "Check command cannot be blank.",
                "warning"
            );
            return;
        }

        try {

            setCheckingConfig(true);

            const response =
                await FactoryStockService.checkConfig({

                    imei: selectedRow.imei,

                    commands: [

                        checkCommand,

                    ],

                });

            setMatched(

                response.data.matched ||

                false

            );

            if (response.data.matched) {
                setStep4Completed(true);
            }

            showSnackbar(

                response.data.matched

                    ? "Configuration Matched"

                    : "Device Not Responded Yet",

                response.data.matched

                    ? "success"

                    : "warning"

            );

            fetchHistory(selectedRow.imei);

        } catch (error) {

            console.log(error);

            showSnackbar(

                "Check Config Failed",

                "error"

            );

        } finally {

            setCheckingConfig(false);

        }

    };

    /* ==========================================
              MARK DONE
    ========================================== */

    const handleMarkDone = async () => {

        try {

            setMarkingDone(true);

            await FactoryStockService.markConfigDone({

                imei: selectedRow.imei,

            });

            showSnackbar(

                "Configuration Completed"

            );

            handleCloseDialog();

            fetchDeviceList();

        } catch (error) {

            console.log(error);

            showSnackbar(
                error?.response?.data?.error ||
                error?.response?.data?.message ||
                "Cannot Mark Done",
                "error"
            );

        } finally {

            setMarkingDone(false);

        }

    };

    const formatIST = (date) => {
        if (!date) return "-";

        return new Date(date).toLocaleString("en-IN", {
            timeZone: "Asia/Kolkata",
            day: "2-digit",
            month: "2-digit",
            year: "numeric",
            hour: "2-digit",
            minute: "2-digit",
            second: "2-digit",
            hour12: true,
        });
    };

    return (
        <Box p={3}>

            {/* =========================
        Search Card
    ========================= */}

            <Card
                elevation={2}
                sx={{
                    mb: 3,
                    borderRadius: 3,
                }}
            >
                <CardContent>

                    <Typography
                        variant="h5"
                        fontWeight="bold"
                        color="primary"
                        mb={3}
                    >
                        Device Configuration Console
                    </Typography>

                    <Stack
                        direction={{
                            xs: "column",
                            md: "row",
                        }}
                        spacing={2}
                        alignItems="center"
                    >

                        <TextField

                            placeholder="Search UID / IMEI / ICCID / ESN..."
                            value={search}
                            onChange={(e) =>
                                setSearch(e.target.value)
                            }
                            onKeyDown={(e) => {
                                if (e.key === "Enter") {
                                    handleSearch();
                                }
                            }}
                        />

                        <Button
                            variant="contained"
                            onClick={handleSearch}
                            sx={{
                                minWidth: 120,
                                height: 56,
                            }}
                        >
                            Search
                        </Button>

                        <Button
                            variant="outlined"
                            onClick={handleReset}
                            sx={{
                                minWidth: 120,
                                height: 56,
                            }}
                        >
                            Reset
                        </Button>

                    </Stack>

                </CardContent>
            </Card>

            {/* =========================
        Device List Card
    ========================= */}

            <Card
                elevation={2}
                sx={{
                    borderRadius: 3,
                }}
            >
                <CardContent>

                    <Typography
                        variant="h6"
                        fontWeight="bold"
                        mb={2}
                    >
                        Devices Ready For Configuration
                    </Typography>

                    <Box
                        sx={{
                            width: "100%",

                            "& .MuiDataGrid-columnHeaders": {
                                backgroundColor: "#f5f5f5",
                                fontWeight: 700,
                            },

                            "& .MuiDataGrid-cell": {
                                display: "flex",
                                alignItems: "center",
                            },
                        }}
                    >

                        <DataGrid

                            autoHeight

                            rows={rows}

                            loading={loading}

                            getRowId={(row) => row.id}

                            pageSizeOptions={[25, 50, 100]}

                            pagination

                            paginationMode="server"

                            rowCount={rowCount}

                            paginationModel={{
                                page,
                                pageSize,
                            }}

                            onPaginationModelChange={(model) => {

                                setPage(model.page);

                                setPageSize(model.pageSize);

                            }}


                            columns={[

                                {
                                    field: "id",
                                    headerName: "ID",
                                    width: 80,
                                },

                                {
                                    field: "uid",
                                    headerName: "UID",
                                    width: 260,
                                },

                                {
                                    field: "imei",
                                    headerName: "IMEI",
                                    width: 170,
                                },

                                {
                                    field: "device_esn",
                                    headerName: "Device ESN",
                                    width: 170,
                                    renderCell: ({ row }) =>
                                        row.device_esn || "-",
                                },

                                {
                                    field: "fota_status",
                                    headerName: "FOTA Status",
                                    width: 170,

                                    renderCell: ({ row }) => (

                                        <Chip

                                            size="small"

                                            color={
                                                ["success", "confirmed", "confirm"].includes(
                                                    (row.fota_status || "").toLowerCase()
                                                )
                                                    ? "success"
                                                    : (row.fota_status || "").toLowerCase() === "failed"
                                                        ? "error"
                                                        : (row.fota_status || "").toLowerCase() === "sent"
                                                            ? "info"
                                                            : "warning"
                                            }

                                            label={
                                                row.fota_status || "Pending"
                                            }

                                        />

                                    ),

                                },

                                {
                                    field: "last_network_provider",
                                    headerName: "Network",
                                    width: 150,

                                    renderCell: ({ row }) =>
                                        row.last_network_provider || "-",

                                },

                                {
                                    field: "last_seen_at",
                                    headerName: "Last Seen",
                                    width: 220,

                                    renderCell: ({ row }) =>
                                        formatIST(row.last_seen_at || "-"),

                                },

                                {
                                    field: "action",

                                    headerName: "Action",

                                    width: 180,

                                    sortable: false,

                                    filterable: false,

                                    renderCell: ({ row }) => (

                                        <Button

                                            variant="contained"

                                            size="small"

                                            onClick={() =>
                                                handleOpenDialog(row)
                                            }

                                        >
                                            Configure
                                        </Button>

                                    ),

                                },

                            ]}

                            slots={{

                                noRowsOverlay: () => (

                                    <Box

                                        sx={{

                                            height: 300,

                                            display: "flex",

                                            justifyContent: "center",

                                            alignItems: "center",

                                            color: "gray",

                                            fontSize: 18,

                                        }}

                                    >

                                        No Device Available

                                    </Box>

                                ),

                            }}

                        />

                    </Box>

                    {/* ==========================================
        DEVICE CONFIGURATION DIALOG
========================================== */}

                    <Dialog
                        open={open}
                        onClose={handleCloseDialog}
                        fullWidth
                        maxWidth="lg"
                    >

                        <DialogTitle
                            sx={{
                                bgcolor: "#1976d2",
                                color: "#fff",
                                fontWeight: 600,
                            }}
                        >
                            Device Configuration Wizard
                        </DialogTitle>

                        <DialogContent sx={{ mt: 2 }}>

                            <Grid container spacing={3}>

                                {/* Left Side */}

                                <Grid item xs={12} md={8}>

                                    <Card
                                        variant="outlined"
                                        sx={{ mb: 3 }}
                                    >

                                        <CardContent>

                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                            >
                                                Step 1 : Send FOTA Command
                                            </Typography>

                                            <Grid container spacing={2}>

                                                {/* Vendor */}

                                                <Grid item xs={12} md={4}>

                                                    <TextField
                                                        select
                                                        fullWidth
                                                        label="Vendor"
                                                        value={vendor}
                                                        onChange={handleVendorChange}
                                                    >

                                                        {vendorList.map((item) => (

                                                            <MenuItem
                                                                key={item.vendor}
                                                                value={item.vendor}
                                                            >
                                                                {item.vendor}
                                                            </MenuItem>

                                                        ))}

                                                    </TextField>

                                                </Grid>

<Grid item xs={12} md={3}>
    <TextField
        select
        fullWidth
        label="Manufacturer"
        value={manufacturer}
        disabled={!vendor}
        onChange={handleManufacturerChange}
    >
        {manufacturerList.map(item => (
            <MenuItem
                key={item.id}
                value={item.id}
            >
                {item.company_name}
            </MenuItem>
        ))}
    </TextField>
</Grid>

                                                {/* Model */}

                                                {/* <Grid item xs={12} md={4}>

                                                    <TextField
                                                        select
                                                        fullWidth
                                                        label="Model"
                                                        value={model}
                                                        disabled={!vendor}
                                                        onChange={handleModelChange}
                                                    >
                                                        {modelList.map((item) => (
                                                            <MenuItem
                                                                key={item.model_id}
                                                                value={item.model_id}
                                                            >
                                                                {item.model_name}
                                                            </MenuItem>
                                                        ))}

                                                    </TextField>

                                                </Grid> */}

                                                <Grid item xs={12} md={3}>
    <TextField
        select
        fullWidth
        label="Model"
        value={model}
        disabled={!manufacturer}
        onChange={handleModelChange}
    >
        {modelList.map(item => (
            <MenuItem
    key={item.id}
    value={item.id}
>
    {item.model_name}
</MenuItem>
        ))}
    </TextField>
</Grid>

                                                {/* Protocol */}

                                                <Grid item xs={12} md={3}>
    <TextField
        select
        fullWidth
        label="Protocol Format"
        value={protocol}
        disabled={!model}
        onChange={handleProtocolChange}
    >
        {firmwareList.map(item => (
            <MenuItem
    key={item.id}
    value={item.fw_name}
>
    {item.fw_name} (v{item.version})
</MenuItem>
        ))}
    </TextField>
</Grid>

                                                {/* <Grid item xs={12} md={4}>
                                                    <TextField
                                                        select
                                                        fullWidth
                                                        label="Manufacturer"
                                                        value={manufacturer}
                                                        disabled={!protocol}
                                                        onChange={(e) => setManufacturer(e.target.value)}
                                                    >
                                                        {manufacturerList.map((item) => (
                                                            <MenuItem
                                                                key={item.id}
                                                                value={item.id}
                                                            >
                                                                {item.company_name}
                                                            </MenuItem>
                                                        ))}
                                                    </TextField>
                                                </Grid>

                                                {/* Send Button */}

                                                <Grid item xs={12}>

                                                    <Button

                                                        variant="contained"

                                                        onClick={handleSendFota}

                                                        disabled={
                                                            sendingFota ||
                                                            !vendor ||
                                                            !model ||
                                                            !protocol ||
                                                            !manufacturer
                                                        }

                                                    >

                                                        {sendingFota ? (

                                                            <CircularProgress
                                                                size={22}
                                                                color="inherit"
                                                            />

                                                        ) : (

                                                            "Send FOTA"

                                                        )}

                                                    </Button>

                                                </Grid>

                                            </Grid>

                                        </CardContent>

                                    </Card>

                                    {/* ==========================================
        STEP 2
========================================== */}

                                    <Card
                                        variant="outlined"
                                        sx={{ mb: 3 }}
                                    >
                                        <CardContent>

                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                            >
                                                Step 2 : Refresh FOTA Status
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                mb={2}
                                            >
                                                Refresh the latest FOTA status from the server.
                                            </Typography>

                                            <Stack
                                                direction="row"
                                                spacing={2}
                                                alignItems="center"
                                                flexWrap="wrap"
                                            >

                                                <Typography
                                                    fontWeight={600}
                                                >
                                                    Current Status :
                                                </Typography>

                                                <Chip
                                                    label={fotaStatus || "Pending"}
                                                    color={
                                                        ["success", "confirmed", "confirm"].includes(
                                                            (fotaStatus || "").toLowerCase()
                                                        )
                                                            ? "success"
                                                            : (fotaStatus || "").toLowerCase() === "failed"
                                                                ? "error"
                                                                : (fotaStatus || "").toLowerCase() === "sent"
                                                                    ? "info"
                                                                    : "warning"
                                                    }
                                                />

                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    onClick={handleRefreshStatus}
                                                    disabled={!step1Completed || refreshingStatus}
                                                >
                                                    {refreshingStatus ? (
                                                        <CircularProgress
                                                            size={22}
                                                            color="inherit"
                                                        />
                                                    ) : (
                                                        "Refresh Status"
                                                    )}
                                                </Button>

                                            </Stack>

                                            {/* Optional Information */}

                                            <Box mt={2}>

                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                >
                                                    IMEI :
                                                    <strong>
                                                        {" "}
                                                        {selectedRow?.imei}
                                                    </strong>
                                                </Typography>

                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                >
                                                    Last Seen :
                                                    <strong>
                                                        {" "}
                                                        {formatIST(selectedRow?.last_seen_at || "-")}
                                                    </strong>
                                                </Typography>

                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                >
                                                    Network :
                                                    <strong>
                                                        {" "}
                                                        {selectedRow?.last_network_provider || "-"}
                                                    </strong>
                                                </Typography>

                                            </Box>

                                        </CardContent>
                                    </Card>

                                    {/* ==========================================
        STEP 3
========================================== */}

                                    <Card
                                        variant="outlined"
                                        sx={{ mb: 3 }}
                                    >
                                        <CardContent>

                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                            >
                                                Step 3 : Send Configuration Commands
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                mb={2}
                                            >
                                                Send one or more configuration commands to the device.
                                            </Typography>

                                            <TextField
                                                fullWidth
                                                multiline
                                                rows={5}
                                                disabled={!step2Completed}
                                                label="Configuration Commands"
                                                placeholder={`SET,APN,internet
SET,SERVER,example.com,8080
SET,MODE,AUTO`}
                                                value={configCommand}
                                                onChange={(e) =>
                                                    setConfigCommand(e.target.value)
                                                }
                                            />

                                            <Box
                                                display="flex"
                                                justifyContent="space-between"
                                                alignItems="center"
                                                mt={2}
                                            >

                                                <Typography
                                                    variant="body2"
                                                    color="text.secondary"
                                                >
                                                    Multiple commands are supported.
                                                    Enter one command per line.
                                                </Typography>

                                                <Button
                                                    variant="contained"
                                                    color="primary"
                                                    disabled={
                                                        !step2Completed ||
                                                        sendingConfig
                                                    }
                                                    onClick={handleSendConfig}
                                                >
                                                    {sendingConfig ? (
                                                        <CircularProgress
                                                            size={22}
                                                            color="inherit"
                                                        />
                                                    ) : (
                                                        "Send Config"
                                                    )}
                                                </Button>

                                            </Box>

                                        </CardContent>
                                    </Card>

                                    {/* ==========================================
        STEP 4 : CHECK CONFIG
========================================== */}

                                    <Card
                                        variant="outlined"
                                        sx={{ mb: 3 }}
                                    >
                                        <CardContent>

                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                            >
                                                Step 4 : Verify Connectivity
                                            </Typography>
                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                mb={2}
                                            >
                                                Sends @GETCONN* and checks the device reports the expected COMMODE/IP1/IP2/EIP. Required before Mark Config Done.
                                            </Typography>
                                            <Button
                                                variant="contained"
                                                color="primary"
                                                disabled={
                                                    !step2Completed ||
                                                    checkingConfig
                                                }
                                                onClick={handleVerifyConnectivity}
                                            >
                                                Verify Connectivity (@GETCONN*)
                                            </Button>

                                            <Typography
                                                variant="subtitle1"
                                                sx={{ mt: 3, mb: 2 }}
                                            >
                                                Step 4 (Optional) : Send Check Config
                                            </Typography>


                                            <TextField
                                                fullWidth
                                                multiline
                                                rows={4}
                                                disabled={!step2Completed}
                                                label="Check Commands"
                                                placeholder={`CHECK,APN
CHECK,SERVER
CHECK,MODE`}
                                                value={checkCommand}
                                                onChange={(e) =>
                                                    setCheckCommand(e.target.value)
                                                }
                                            />

                                            <Stack
                                                direction="row"
                                                spacing={2}
                                                alignItems="center"
                                                justifyContent="space-between"
                                                mt={2}
                                                flexWrap="wrap"
                                            >

                                                <Stack
                                                    direction="row"
                                                    spacing={2}
                                                    alignItems="center"
                                                >

                                                    <Typography
                                                        fontWeight={600}
                                                    >
                                                        Device Response :
                                                    </Typography>

                                                    <Chip
                                                        label={
                                                            matched
                                                                ? "Matched"
                                                                : "Waiting"
                                                        }
                                                        color={
                                                            matched
                                                                ? "success"
                                                                : "warning"
                                                        }
                                                    />

                                                </Stack>

                                                <Button
                                                    variant="contained"
                                                    color="secondary"
                                                    disabled={
                                                        !step2Completed ||
                                                        checkingConfig
                                                    }
                                                    onClick={handleCheckConfig}
                                                >
                                                    {checkingConfig ? (
                                                        <CircularProgress
                                                            size={22}
                                                            color="inherit"
                                                        />
                                                    ) : (
                                                        "Check Configuration"
                                                    )}
                                                </Button>

                                            </Stack>

                                            <Box mt={2}>

                                                <Alert severity="info">

                                                    If the device is slow to respond,
                                                    click
                                                    <strong>
                                                        {" "}
                                                        Check Configuration
                                                    </strong>
                                                    again after a few seconds.

                                                </Alert>

                                            </Box>

                                        </CardContent>
                                    </Card>

                                </Grid>

                                {/* Right Side */}

                                <Grid item xs={12} md={4}>

                                    <Card variant="outlined">

                                        <CardContent>

                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                            >
                                                Device Details
                                            </Typography>

                                            <Typography>
                                                <strong>IMEI :</strong>{" "}
                                                {selectedRow?.imei}
                                            </Typography>

                                            <Typography>
                                                <strong>UID :</strong>{" "}
                                                {selectedRow?.uid}
                                            </Typography>

                                            <Typography>
                                                <strong>ICCID :</strong>{" "}
                                                {selectedRow?.iccid_primary}
                                            </Typography>

                                            <Typography>
                                                <strong>ESN :</strong>{" "}
                                                {selectedRow?.device_esn || "-"}
                                            </Typography>

                                        </CardContent>

                                    </Card>

                                    {/* ==========================================
        COMMAND HISTORY
========================================== */}

                                    <Card
                                        variant="outlined"
                                        sx={{
                                            mt: 3,
                                        }}
                                    >
                                        <CardContent>

                                            <Typography
                                                variant="h6"
                                                gutterBottom
                                            >
                                                Command History
                                            </Typography>

                                            <Typography
                                                variant="body2"
                                                color="text.secondary"
                                                mb={2}
                                            >
                                                Live command log received from the server.
                                            </Typography>

                                            <Box
                                                sx={{
                                                    maxHeight: 450,
                                                    overflowY: "auto",
                                                    pr: 1,
                                                }}
                                            >

                                                {history.length === 0 ? (

                                                    <Typography
                                                        color="text.secondary"
                                                        align="center"
                                                        sx={{
                                                            py: 4,
                                                        }}
                                                    >
                                                        No command history available.
                                                    </Typography>

                                                ) : (

                                                    history.map((item, index) => (

                                                        <Card
                                                            key={index}
                                                            variant="outlined"
                                                            sx={{
                                                                mb: 2,
                                                            }}
                                                        >

                                                            <CardContent>

                                                                <Typography fontWeight={600}>
                                                                    {item.payload}
                                                                </Typography>

                                                                <Chip
                                                                    label={item.result}
                                                                    color={
                                                                        item.result === "delivered"
                                                                            ? "success"
                                                                            : item.result === "failed"
                                                                                ? "error"
                                                                                : "warning"
                                                                    }
                                                                />

                                                                <Typography variant="body2">
                                                                    Transport : {item.transport}
                                                                </Typography>

                                                                <Typography variant="body2">
                                                                    Sent By : {item.sent_by}
                                                                </Typography>

                                                                <Typography variant="caption">
                                                                    {formatIST(item.sent_at)}
                                                                </Typography>
                                                            </CardContent>

                                                        </Card>

                                                    ))

                                                )}

                                            </Box>

                                            <Button
                                                fullWidth
                                                variant="outlined"
                                                sx={{
                                                    mt: 2,
                                                }}
                                                onClick={() =>
                                                    fetchHistory(
                                                        selectedRow?.imei
                                                    )
                                                }
                                            >
                                                Refresh History
                                            </Button>

                                        </CardContent>
                                    </Card>

                                </Grid>

                            </Grid>

                        </DialogContent>

                        <DialogActions
                            sx={{
                                px: 3,
                                py: 2,
                                justifyContent: "space-between",
                            }}
                        >

                            <Typography
                                variant="body2"
                                color="text.secondary"
                            >
                                Complete all required configuration steps before marking the device as done.
                            </Typography>

                            <Stack
                                direction="row"
                                spacing={2}
                            >

                                <Button
                                    variant="outlined"
                                    onClick={handleCloseDialog}
                                >
                                    Close
                                </Button>

                                <Button
                                    variant="contained"
                                    color="success"
                                    disabled={
                                        !step4Completed ||
                                        markingDone
                                    }
                                    onClick={handleMarkDone}
                                >

                                    {markingDone ? (

                                        <CircularProgress
                                            size={22}
                                            color="inherit"
                                        />

                                    ) : (

                                        "Mark Configuration Done"

                                    )}

                                </Button>

                            </Stack>

                        </DialogActions>

                    </Dialog>

                    <Snackbar
                        open={snackbar.open}
                        autoHideDuration={3000}
                        anchorOrigin={{
                            vertical: "top",
                            horizontal: "right",
                        }}
                        onClose={() =>
                            setSnackbar({
                                ...snackbar,
                                open: false,
                            })
                        }
                    >

                        <Alert
                            severity={snackbar.severity}
                            variant="filled"
                            onClose={() =>
                                setSnackbar({
                                    ...snackbar,
                                    open: false,
                                })
                            }
                            sx={{
                                width: "100%",
                            }}
                        >
                            {snackbar.message}
                        </Alert>

                    </Snackbar>
                </CardContent>
            </Card>
        </Box>

    );

};

export default DeviceConfigConsole;